<template>
  <div>
    <div style="min-width: 100%; max-width: 100%; max-height: 40vh;">
      <table style="min-width: 100%; max-width: 100%;">
        <THeaders
          :fornecedores="fornecedores"
        />

        <TBody
          :fornecedores="fornecedores"
          :back_checkbox="back_checkbox"
          :itens="itens"
          :prop_categorias_checkbox="checkbox_categorias"
          @atualizar-categorias="atualizarCategoriaCheckbox($event)"
        />
      </table>
    </div>

    <div style="min-width: 100%; max-width: 100%; max-height: 24vh;">
      <p class="font-16 mt-5 mb-0">Produtos a comprar</p>

      <v-chip
        v-for="(cat, idx) in chip_categorias"
        :key="idx"
        color="#00897B"
        close
        close-icon="mdi-close-outline"
        outlined
        chips
        small
        class="ma-1 font-weight-bold"
        solo
        @click:close="removerCategoriaChip(cat)"
      >
        {{ cat.idcategoria + ' - ' + cat.descricao_categoria }}
      </v-chip>
    </div>
  </div>
</template>

<script>
import THeaders from "./THeaders.vue";
import TBody from "./TBody.vue";

export default {
  name: "ListaDeProdutos",
  components: {
    THeaders,
    TBody
  },
  data() {
    return {
      checkbox_categorias: [],
      chip_categorias: [],
    }
  },
  props: ['cotacoes_para_analise'],
  computed: {
    itens() {
      const itens = this.cotacoes_para_analise.data;
      return itens;
    },
    fornecedores() {
      const itens = this.cotacoes_para_analise.fornecedores;
      return itens;
    },
    back_checkbox() {
      const itens = this.cotacoes_para_analise.checkbox;
      return itens;
    }
  },
  methods: {
    atualizarCategoriaCheckbox(evento) {
      this.$emit('categorias-selecinadas', evento);
      this.checkbox_categorias = evento;

      if (evento.length === 0 ) {
        this.chip_categorias = [];
        return;
      }

      this.chip_categorias = evento.map(e => {
        const parse = JSON.parse(e);

        const dado = {
          ...this.back_checkbox[parse[0]][parse[1]][parse[2]],
          idfornecedor: parse[1],
          iddepartamento: parse[0]
        };

        return dado;
      });
    },
    removerCategoriaChip(evento) {
      const evt = JSON.stringify([evento.iddepartamento, evento.idfornecedor, evento.idcategoria]);
      this.checkbox_categorias = this.checkbox_categorias.filter(fcc => fcc != evt);

      this.chip_categorias = this.chip_categorias.filter(cc => {
        const stringify =  JSON.stringify([cc.iddepartamento, cc.idfornecedor, cc.idcategoria]);
        return stringify != evt;
      });
    }
  }
}
</script>

<style scoped>
div {
  height: calc(100vh - 250px);
  width: 100%;
  overflow: auto;
}
table {
  border-collapse: collapse;
  font-size: 12px;
}
</style>
